import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CarbonFootprintData, FertigationRate } from "../../../types";

interface CarbonFootprintTableState {
    tableData: CarbonFootprintData[];
}

type CFPTableValues = {
    traditional: number;
    multicoteTechnology: number;
    fertigationRating: FertigationRate;
};

type CFPTableActionPayload = PayloadAction<CFPTableValues>;

type CFPTableEntireActionPayload = PayloadAction<{
    carbonFootprint: CFPTableValues;
    nitrogenLeaching: CFPTableValues;
    nitrogenRunoff: CFPTableValues;
    nitrogenVolatilization: CFPTableValues;
    nitrogenTerrestrialEutrophication: CFPTableValues;
    // nitrogenMarinetrialEutrophication: CFPTableValues;
}>;

const initialState: CarbonFootprintTableState = {
    tableData: [
        {
            environmentalParameter: "Carbon footprint",
            measureUnit: "kg CO2 eq./Kg produce",
            multicoteTechnology: null,
            traditional: null,
            fertigationRating: null,
        },
        {
            environmentalParameter: "N leaching",
            measureUnit: "kg NO3/Kg produce",
            multicoteTechnology: null,
            traditional: null,
            fertigationRating: null,
        },
        {
            environmentalParameter: "N runoff",
            measureUnit: "kg NO3/Kg produce",
            multicoteTechnology: null,
            traditional: null,
            fertigationRating: null,
        },
        {
            environmentalParameter: "N volatilization",
            measureUnit: "kg NH3/Kg produce",
            multicoteTechnology: null,
            traditional: null,
            fertigationRating: null,
        },
        {
            environmentalParameter: "Terrestrial eutrophication",
            measureUnit: "kg P eq./Kg produce",
            multicoteTechnology: null,
            traditional: null,
            fertigationRating: null,
        },
        // {
        //     environmentalParameter: "Marine eutrophication",
        //     measureUnit: "kg P eq./Kg produce",
        //     multicoteTechnology: null,
        //     traditional: null,
        //     fertigationRating: null,
        // },
    ],
};

// WE SHOULD ADD THE FERTIGATION RATING ONCE WE HAVE THE CALCULATION FOR IT
// IT WOULD BE ANOTHER PARAMETER PASSED IN THE ACTION PAYLOAD

const slice = createSlice({
    name: "CarbonFootprintTable",
    initialState,
    reducers: {
        setCarbonFootprint: (state, action: CFPTableActionPayload) => {
            state.tableData[0].traditional = action.payload.traditional;
            state.tableData[0].multicoteTechnology = action.payload.multicoteTechnology;
        },
        setNitrogenLeaching: (state, action: CFPTableActionPayload) => {
            state.tableData[1].traditional = action.payload.traditional;
            state.tableData[1].multicoteTechnology = action.payload.multicoteTechnology;
        },
        setNitrogenRunoff: (state, action: CFPTableActionPayload) => {
            state.tableData[2].traditional = action.payload.traditional;
            state.tableData[2].multicoteTechnology = action.payload.multicoteTechnology;
        },
        setNitrogenVolatilization: (state, action: CFPTableActionPayload) => {
            state.tableData[3].traditional = action.payload.traditional;
            state.tableData[3].multicoteTechnology = action.payload.multicoteTechnology;
        },
        setNitrogenTerrestrialEutrophication: (state, action: CFPTableActionPayload) => {
            state.tableData[4].traditional = action.payload.traditional;
            state.tableData[4].multicoteTechnology = action.payload.multicoteTechnology;
        },
        // setNitrogenMarinelEutrophication: (state, action: CFPTableActionPayload) => {
        //     state.tableData[5].traditional = action.payload.traditional;
        //     state.tableData[5].multicoteTechnology = action.payload.multicoteTechnology;
        // },
        setEntireValues: (state, action: CFPTableEntireActionPayload) => {
            state.tableData = [
                {
                    ...state.tableData[0],
                    traditional: action.payload.carbonFootprint.traditional,
                    multicoteTechnology: action.payload.carbonFootprint.multicoteTechnology,
                    fertigationRating: action.payload.carbonFootprint.fertigationRating,
                },
                {
                    ...state.tableData[1],
                    traditional: action.payload.nitrogenLeaching.traditional,
                    multicoteTechnology: action.payload.nitrogenLeaching.multicoteTechnology,
                    fertigationRating: action.payload.nitrogenLeaching.fertigationRating,
                },
                {
                    ...state.tableData[2],
                    traditional: action.payload.nitrogenRunoff.traditional,
                    multicoteTechnology: action.payload.nitrogenRunoff.multicoteTechnology,
                    fertigationRating: action.payload.nitrogenRunoff.fertigationRating,
                },
                {
                    ...state.tableData[3],
                    traditional: action.payload.nitrogenVolatilization.traditional,
                    multicoteTechnology: action.payload.nitrogenVolatilization.multicoteTechnology,
                    fertigationRating: action.payload.nitrogenVolatilization.fertigationRating,
                },
                {
                    ...state.tableData[4],
                    traditional: action.payload.nitrogenTerrestrialEutrophication.traditional,
                    multicoteTechnology: action.payload.nitrogenTerrestrialEutrophication.multicoteTechnology,
                    fertigationRating: action.payload.nitrogenTerrestrialEutrophication.fertigationRating,
                },
                // {
                //     ...state.tableData[5],
                //     traditional: action.payload.nitrogenMarinetrialEutrophication.traditional,
                //     multicoteTechnology: action.payload.nitrogenMarinetrialEutrophication.multicoteTechnology,
                //     fertigationRating: action.payload.nitrogenMarinetrialEutrophication.fertigationRating,
                // },
            ];
        },
    },
});

export const CFPTableActions = slice.actions;
export default slice.reducer;
